import { createSlice, createSelector } from '@reduxjs/toolkit'

import { addToGroup } from '../common_actions'

const sliceSelector = (state) => state.userGroups.add_members
export const pendingSelector = createSelector(sliceSelector, ({ pending }) => pending)
export const isPopupOpenSelector = createSelector(sliceSelector, ({ isPopupOpen }) => isPopupOpen)

const initialState = {
  pending: false,
  isPopupOpen: false
}

const slice = createSlice({
  name: 'userGroup/addMembers',
  initialState,
  reducers: {
    openPopup(state) {
      state.isPopupOpen = true
    },
    closePopup(state) {
      state.isPopupOpen = false
    }
  },
  extraReducers: (builder) => {
    builder.addCase(addToGroup.pending, (state) => {
      state.pending = true
    })
    builder.addCase(addToGroup.fulfilled, (state) => {
      state.pending = false
      state.isPopupOpen = false
    })
    builder.addCase(addToGroup.rejected, (state) => {
      state.pending = false
    })
  }
})

export const { openPopup, closePopup } = slice.actions
export const { reducer } = slice
